import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ProjectListComponent} from './project-list/project-list.component';
import {ProjectDetailComponent} from './project-detail/project-detail.component';
import {ProjetcGraphsComponent} from './projetc-graphs/projetc-graphs.component';
import {MainPageComponent} from './main-page/main-page.component';

const routes: Routes = [
  {path: 'vypis', component: ProjectListComponent},
  {path: 'statistiky', component: ProjetcGraphsComponent},
  {path: 'detail_projektu/:id', component: ProjectDetailComponent},
  {path: '', component: MainPageComponent},
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
